export default __webpack_public_path__ + "static/cover-f2edfd8522536cf584ccf9118b2d44e9.jpg";